import styled, { css } from "styled-components";

export const InputWrapper = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  outline: none;
  min-width: 150px;

  font-size: 16px;
  font-weight: 400;
  color: ${window?.settings?.secondary_color ?? '#04333b'};

  ::placeholder {
    color: #9EACB0;
  }

  ${p => p.labelInside && css`
    margin-left: 5px;
    font-size: 12px;

    ::placeholder {
      font-weight: 500;
    }
  `}

  &:disabled {
    color: #E3E3E3;
    background-color: unset;
  }
`;